import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GeneratedSalarySlip from "./GeneratedSalarySlip";

const GeneratedSalarySlipPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const slipData = location.state?.slipData;

    // If user directly opens this URL without generating a slip
    if (!slipData) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-[#F7F8FA]">
                <div className="text-center">
                    <p className="mb-4 text-gray-600">
                        No salary slip found.
                    </p>

                    <button
                        type="button"
                        onClick={() => navigate("/free-payslip-generator")}
                        className="rounded-lg bg-[#1A365D] px-5 py-2 text-white"
                    >
                        Generate Salary Slip
                    </button>
                </div>
            </div>
        );
    }

    return (
        <GeneratedSalarySlip data={slipData} />
    );
};

export default GeneratedSalarySlipPage;